(function () {
  'use strict';

  var STORAGE_KEY = 'joe_wishlist';
  var config = window.JoeWishlistAccount || {};
  var customerId = config.customerId ? String(config.customerId) : '';
  var apiBaseUrl = String(config.apiBaseUrl || '').replace(/\/$/, '');
  var saveTimer = null;
  var applyingRemote = false;

  if (!customerId || !apiBaseUrl) return;

  function getWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    var next = Array.isArray(list) ? list : [];
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      console.warn('Wishlist account sync: failed to save local wishlist', e);
    }

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      bubbles: true,
      detail: { wishlist: next, count: next.length }
    }));
  }

  function request(path, method, wishlist) {
    return fetch(apiBaseUrl + path + '?customerId=' + encodeURIComponent(customerId), {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: wishlist ? JSON.stringify({ wishlist: wishlist }) : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Wishlist sync failed');
      return response.json();
    });
  }

  function mergeOnLoad() {
    request('/wishlist/merge', 'POST', getWishlist())
      .then(function (result) {
        if (!result || !Array.isArray(result.wishlist)) return;
        applyingRemote = true;
        setWishlist(result.wishlist);
        applyingRemote = false;
      })
      .catch(function (e) {
        console.warn('Wishlist account sync: merge failed', e);
      });
  }

  function saveRemote(list) {
    request('/wishlist', 'PUT', list).catch(function (e) {
      console.warn('Wishlist account sync: save failed', e);
    });
  }

  document.addEventListener('wishlist:updated', function (event) {
    if (applyingRemote) return;

    var list = event.detail && Array.isArray(event.detail.wishlist)
      ? event.detail.wishlist
      : getWishlist();

    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () {
      saveRemote(list);
    }, 350);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeOnLoad);
  } else {
    mergeOnLoad();
  }
})();
